import { PaymentElement } from '@stripe/react-stripe-js';
import { useField } from 'react-final-form';
import { SecuredByStripe } from 'components/SecuredByStripe';

export const PaymentDetails = () => {
  const {
    input: { value: email },
  } = useField('email', { subscription: { value: true } });

  return (
    <div className="payment-details">
      <div className="details-header">
        <span className="body-text">Payment Details</span>
        <SecuredByStripe />
      </div>
      <PaymentElement
        id="payment-element"
        options={{
          defaultValues: {
            billingDetails: {
              email,
            },
          },
        }}
      />
    </div>
  );
};
